import styled from 'styled-components';

export const Footer = styled.footer`
  text-align: center;
  background-color: ${({ theme }) => theme.colors.gray100};
`;
